import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class EventBusService {
    // Observable string sources
    private emitChangeSource = new Subject<IEventBusPacket>();
    // Observable string streams
    changeEmitted = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(eventType: string, data: any = null) {
        const change: IEventBusPacket = {
            EventType: eventType,
            Data: data
        };
        this.emitChangeSource.next(change);
    }
}

export interface IEventBusPacket {
    EventType: string;
    Data?: any;
}

export class EventBusPackeData_Generic {
    id?: string;
    pageName?: string;
    screenNumber?: string;
    text?: string;
}

export class EventBusPacket implements IEventBusPacket {
    EventType: string;
    Data?: EventBusPackeData_Generic;
}
